import { createSlice } from "@reduxjs/toolkit";

import { createSofEntry, deleteSofEntry, getSof, updateSofEntry } from "../thunks/sofThunk";

interface SofState {
  sofStatement: any[];
  total: number;
  loading: boolean;
  error: string | null;
}

const initialState: SofState = {
  sofStatement: [],
  total: 0,
  loading: false,
  error: null,
};

const sofSlice = createSlice({
  name: "sof",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSof.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSof.fulfilled, (state, action) => {
        state.loading = false;
        state.sofStatement = action.payload?.data || [];
        state.total = action.payload.total;
      })
      .addCase(getSof.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(updateSofEntry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSofEntry.fulfilled, (state, action) => {
        state.loading = false;
        const { id, data: updatedEntry } = action.payload;
        if (updatedEntry) {
          state.sofStatement = state.sofStatement.map((entry) =>
            entry.csof_entry_id === id ? { ...entry, ...updatedEntry } : entry
          );
        }
      })
      .addCase(updateSofEntry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(createSofEntry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSofEntry.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.sofStatement = [...state.sofStatement, action.payload];
          state.total += 1;
        }
      })
      .addCase(createSofEntry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(deleteSofEntry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSofEntry.fulfilled, (state, action) => {
        state.loading = false;
        const { id } = action.payload;
        state.sofStatement = state.sofStatement.filter(
          (entry) => entry.csof_entry_id !== id
        );
        state.total -= 1;
      })
      .addCase(deleteSofEntry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default sofSlice.reducer;
